import * as React from 'react';
import ContractListItem from './ContractListItem';
import Section from './Section';
import { Contract } from '../contract';

const activeContracts = (contracts: Contract[]) => {
  return contracts.filter((contract: Contract) => contract.is_active);
};

const inactiveContracts = (contracts: Contract[]) => {
  return contracts.filter((contract: Contract) => !contract.is_active);
};

const mapToContractItem = (contract: Contract, index: number) => (
  <ContractListItem contract={contract} key={index} />
);

type Props = {
  contracts: Contract[];
};

export default function ContractList(props: Props) {
  const inactive = inactiveContracts(props.contracts);

  return (
    <React.Fragment>
      <Section title="Active">
        {activeContracts(props.contracts).map(mapToContractItem)}
      </Section>
      {inactive.length ? (
        <Section title="Inactive">{inactive.map(mapToContractItem)}</Section>
      ) : null}
    </React.Fragment>
  );
}
